import { ReactNode } from 'react'
import { PageShell } from '../../components/layout/PageShell'
import { PageBrow } from '../../components/layout/PageBrow'

/**
 * Thin shell for the workspace "vision" dashboards (CRM / Finance / Service /
 * AI). The primary rail (PrimarySidebar) already switches domains, so these
 * pages carry no secondary rail — just the standard §4.8 brow (title + subtitle)
 * over a padded, scrolling body. Replaces the old 260px WorkspaceLayout aside.
 */
export default function DashboardPage({
  title,
  subtitle,
  actions,
  children,
}: {
  title: string
  subtitle?: string
  actions?: ReactNode
  children: ReactNode
}) {
  return (
    <PageShell
      brow={
        <PageBrow
          left={
            <div className="min-w-0">
              <h1 className="truncate text-[15px] font-semibold text-foreground">{title}</h1>
              {subtitle && <p className="truncate text-xs text-muted-foreground">{subtitle}</p>}
            </div>
          }
          right={actions}
        />
      }
    >
      <div className="space-y-6 p-6">{children}</div>
    </PageShell>
  )
}
